export default "__VITE_ASSET__CZpzrPB2__"